import React, { useMemo } from 'react';
import { Thumbnail } from '@remotion/player';
import { CarouselVideo, CarouselVideoProps, SlideData } from './compositions/CarouselVideo';
import { createPreviewCoverChoreography } from './CarouselVideoPreview';

const FPS = 30;

/**
 * A slide as it publishes to a story: the 9:16 video layout of that slide,
 * still, with every overlay shown. Matches the server's story frame render.
 */
export const StoryFramePreview: React.FC<{ slide: SlideData; style?: React.CSSProperties }> = ({
  slide,
  style,
}) => {
  const inputProps = useMemo<CarouselVideoProps>(
    () => ({
      slides: [slide],
      choreography: createPreviewCoverChoreography(slide, FPS),
      width: 1080,
      height: 1920,
      referenceWidth: slide.dimensions.width,
      referenceHeight: slide.dimensions.height,
      layoutEngine: 'remotion',
      fillMode: 'adaptive',
    }),
    [slide],
  );
  return (
    <Thumbnail
      component={CarouselVideo}
      inputProps={inputProps}
      durationInFrames={FPS}
      frameToDisplay={0}
      fps={FPS}
      compositionWidth={1080}
      compositionHeight={1920}
      style={{ width: '100%', height: '100%', ...style }}
      renderLoading={() => null}
    />
  );
};
